import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-job-notes',
  templateUrl: './job-notes.component.html',
  styleUrls: ['./job-notes.component.scss']
})
export class JobNotesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
